import React from "react";
import { Field, InputContainer, Label, ValidateHelp } from "../input/styles";

type EmailInputProps = {
  label: string;
  name: string;
  placeholder?: string;
  value?: string | number;
  hasError?: boolean;
  error?: string;
  register?: any; // react-hook-form register
  required?: any;
};

const EmailInput: React.FC<EmailInputProps> = ({
  label,
  name,
  placeholder,
  value,
  hasError,
  error,
  register,
  required,
}) => {
  const [messageError, setMessageError] = React.useState("");

  React.useEffect(() => {
    if (hasError && error) {
      setMessageError(error);
    } else {
      setMessageError("");
    }
  }, [hasError, error]);

  const sanitize = (input: HTMLInputElement) => {
    // lowercase and remove ALL whitespace
    input.value = input.value.toLowerCase().replace(/\s+/g, "");
  };

  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    sanitize(event.currentTarget);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    sanitize(event.currentTarget);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    sanitize(event.currentTarget);
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const target = event.currentTarget;
    requestAnimationFrame(() => sanitize(target));
  };

  const registerReturn = register
    ? register(name, {
        required,
        setValueAs: (v: unknown) => {
          if (typeof v !== "string") return v as any;
          return v.toLowerCase().replace(/\s+/g, "");
        },
      })
    : undefined;

  return (
    <InputContainer>
      <Label>{label}</Label>
      <Field
        hasError={!!(hasError && error)}
        type="email"
        inputMode="email"
        autoComplete="email"
        value={value}
        placeholder={placeholder}
        {...(registerReturn || {})}
        onInput={handleInput}
        onChange={(e) => {
          handleChange(e);
          registerReturn && registerReturn.onChange(e);
        }}
        onBlur={(e) => {
          handleBlur(e);
          registerReturn && registerReturn.onBlur(e);
        }}
        onPaste={handlePaste}
      />
      <ValidateHelp>{messageError || ""}</ValidateHelp>
    </InputContainer>
  );
};

export default EmailInput;


